define('gigaset_csp/components/order/repair/form/description',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"bootstrap-button"
], function(
	$,
	Component,
	BEM
) {
	return Component.create({
		block: null,

		faqRadios:			null,
		compatRadios:		null,
		solvedAloneRadios:	null,


		form:				null,
		varienForm:			null,
		submitButton:		null,

		config:				null,

		$init: function() {
			var self = this;

			this.block = BEM.block("csp-repair-order-register-form-description");

			this.faqRadios = this.block.getElements("lookup-faq");
			this.compatRadios = this.block.getElements("checked-compatibility");
			this.solvedAloneRadios = this.block.getElements("solved-alone");

			this.faqRadios.on("change", $.proxy(this._onRadioChange, this));
			this.compatRadios.on("change", $.proxy(this._onRadioChange, this));

			this.config = this.block.data("config");

			this.form = this.block.getElements("form");
			this.submitButton = this.block.getElements("submit-button");
			this.varienForm = new VarienForm(this.form.get(0));

			this.form.on("submit", $.proxy(this._onFormSubmit, this));
		},

		_onRadioChange: function(e) {
			var continueRadio = this.solvedAloneRadios.filter(function() { return this.value == 0; })
				, enable = true;

			this.faqRadios.each(function() {
				if (this.checked && this.value == 0) {
					enable = false;
					return false;
				}
			});

			this.compatRadios.each(function() {
				if (this.checked && this.value == 0) {
					enable = false;
					return false;
				}
			});

			if (enable) {
				continueRadio.removeAttr("disabled");
			} else {
				continueRadio.attr("disabled", "disabled");
				continueRadio.removeAttr("checked");
			}
		},

		_onFormSubmit: function(e) {
			if (!this.varienForm.validator.validate()) {
				e.preventDefault();
				return;
			}

			this.block.addModifier("submitting");
			this.submitButton.button("loading");
		}
	});
});
